import _ from 'underscore';
import ko from 'knockout';

/**
 * extend checkbox observable define
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @param {FieldOption} fieldOption - field of property
 * @returns {undefined} - no returns
 */
export function checkbox(local, attrs, fieldOption) {
  if (!fieldOption.values) {
    throw new Error('pass custom values as [checked-value, not-checked-value] in!');
  }

  if (!_.contains(_.first(fieldOption.values, 2), local())) {
    local(fieldOption.values[1]);
  }

  _.extend(local, {
    checkbox: ko.computed({
      read: () => fieldOption.values[0] === local(),
      write: (value) => {
        local(fieldOption.values[value ? 0 : 1]);
      },
    }),
  });
}
